export default __webpack_public_path__ + "static/media/wzlkz.97315162.png";